/**
 * NotificationBell — o sino do cabeçalho (Story 2.5; parte D1, 01/10/2026).
 *
 * Desktop: Popover (o painel tem um Switch e dois links; o `menuitem` do DropdownMenu
 * brigava com o Switch no teclado e no leitor de tela). Celular (`compacto`): folha de
 * baixo, gatilho de 44 px — o polegar está embaixo e a lista rola com o cabeçalho e o
 * rodapé fixos. O conteúdo é um só: `PainelDoSino`; o Popover e a folha moram no `InvolucroDoSino`
 * (o sino do portal usa o mesmo). Contador: exato até 99, depois "99+".
 *
 * Saiu o estado "sino silenciado" (`useMutingStatus`): consultava a API a cada minuto,
 * por aba, um estado que nenhuma tela roteada liga (spec §6.5).
 */
import React from "react";
import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNotifications } from "@/contexts/NotificationContext";
import { cn } from "@/lib/utils";
import { InvolucroDoSino } from "./InvolucroDoSino";
import { PainelDoSino } from "./PainelDoSino";

interface Props {
  /** Celular: folha de baixo e alvo de 44 px. */
  compacto?: boolean;
}

const NotificationBell: React.FC<Props> = ({ compacto = false }) => {
  const fonte = useNotifications();
  const { unreadCount } = fonte;

  const gatilho = (
    <Button
      variant="ghost"
      size="sm"
      className={cn(
        "relative",
        compacto ? "h-11 w-11 min-h-[44px] min-w-[44px]" : "min-h-[32px] min-w-[32px]"
      )}
      aria-label={`Notificações (${unreadCount} não lidas)`}
      aria-haspopup="dialog"
    >
      <Bell className={compacto ? "h-5 w-5" : "h-4 w-4"} />
      {unreadCount > 0 && (
        <span
          aria-hidden="true"
          className={cn(
            "absolute -top-1 -right-1 flex items-center justify-center rounded-full bg-red-500 px-0.5 text-[10px] font-medium text-white",
            compacto ? "h-[18px] min-w-[18px]" : "h-4 min-w-[16px]"
          )}
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </Button>
  );

  return (
    <InvolucroDoSino gatilho={gatilho} compacto={compacto}>
      {({ aoFechar, titulo }) => (
        <PainelDoSino compacto={compacto} titulo={titulo} aoFechar={aoFechar} fonte={fonte} />
      )}
    </InvolucroDoSino>
  );
};

export default NotificationBell;
